

import { imagens } from './valores_estaticos'
import * as React from 'react';

export const loader = () => {

    return (<div style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        paddingTop: '10%',

    }}>

        <img height="100"
            width="80" src={imagens.loader_gif} alt="My Image" />

        {/* <Circles
      height="80"
      width="80"
      color={cores.cor2}
      ariaLabel="circles-loading"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
    /> */}
    </div>)

}
